import { useTranslation } from "react-i18next";

// ظل ثلاثي الأبعاد موحّد لكل بطاقات المحاسبة (HELCOO 3D Neu — Card).
export const CARD_3D_STYLE = {
  boxShadow:
    "0 14px 28px rgba(0,0,0,0.32), 0 8px 12px rgba(0,0,0,0.20),"
    + " inset 0 1.5px 0 rgba(255,255,255,0.28), inset 0 -4px 10px rgba(0,0,0,0.18)",
};

// بطاقة قسم بروز 3D + عنوان ملوّن.
export const Card3D = ({ titleKey, children, className = "", testid, headerRight }) => {
  const { t } = useTranslation();
  return (
    <div className={`animate-rise-in rounded-3xl border border-border/50 bg-background/70 p-5 ${className}`}
         style={CARD_3D_STYLE} data-testid={testid}>
      {titleKey ? (
        <div className="mb-4 flex items-center justify-between gap-3">
          <p className="text-xs font-black uppercase tracking-wide text-primary">
            {t(titleKey)}
          </p>
          {headerRight}
        </div>
      ) : null}
      {children}
    </div>
  );
};
